import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ActionItemIcon = styled(Box, {
  shouldForwardProp: (prop) => !['bgcolor', 'svgdimensions'].includes(prop),
})(({ bgcolor, svgdimensions = {} }) => ({
  marginRight: 10,
  backgroundColor: bgcolor,
  height: '36px',
  width: '36px',
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 36px',
  justifyContent: 'center',
  borderRadius: 8,
  gap: '10px',
  '& > svg': {
    ...svgdimensions,
  },
}));
